import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface IntegrationsStepProps {
  value: string[];
  onChange: (next: string[]) => void;
}

const INTEGRATIONS = [
  "Salesforce",
  "HubSpot",
  "Podio",
  "GoHighLevel",
  "Airtable",
  "Zapier",
  "Google Calendar",
  "PropStream",
  "BatchLeads",
  "REISift",
  "Carrot",
  "Zillow / Realtor.com",
];

export default function IntegrationsStep({ value, onChange }: IntegrationsStepProps) {
  const toggle = (tool: string) => {
    const next = value.includes(tool)
      ? value.filter((t) => t !== tool)
      : [...value, tool];
    onChange(next);
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold">Anything you already use?</h2>
        <p className="text-sm text-muted-foreground">
          We'll add relevant integration setup to your checklist. Skip if you're not sure.
        </p>
      </div>

      <div className="space-y-2">
        <Label>Select all that apply</Label>
        <div className="grid grid-cols-2 gap-2">
          {INTEGRATIONS.map((tool) => (
            <label
              key={tool}
              className="flex items-center gap-2 p-2 rounded-md hover:bg-muted/50 cursor-pointer"
            >
              <Checkbox
                checked={value.includes(tool)}
                onCheckedChange={() => toggle(tool)}
              />
              <span className="text-sm">{tool}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
